export default __webpack_public_path__ + "33e57db97c408bf32633ad00a8bb5d40.png";